<template>
  <div class="box3">
    <div class="wrapper">
      <pageTitle
        title="AI测试&nbsp;&nbsp;刚需不可替代"
        text="不管技术如何变化，只要有软件存在，测试就永远是刚需"
        titleColor="#24375C"
        titColor="#86909C"
      />
    </div>

    <div class="subject-content">
      <swiper :options="swiperOption" ref="mySwiper" class="swiperitems">
        <swiper-slide
          class="swiperwrap"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="card">
            <div class="card__header">
              <img
                src="../../../assets/coursePage/softwareTest/box3/card-icon.png"
                alt=""
                class="card__icon"
              />
              <h3 class="card__title">{{ item.title }}</h3>
            </div>
            <img
              :src="item.image"
              :alt="item.title"
              class="card__chart"
              :class="`card__chart--${index}`"
            />
            <div class="card__footer">
              <template v-if="index === 0">
                <p class="card__footer-text">{{ item.footer[0] }}</p>
                <p class="card__footer-highlight">{{ item.footer[1] }}</p>
              </template>
              <template v-else-if="index === 1">
                <p class="card__footer-text">{{ item.footer[0] }}</p>
                <p class="card__footer-text">
                  {{ item.footer[1] }}
                  <span class="card__footer-em">{{ item.footer[2] }}</span>
                </p>
              </template>
              <template v-else>
                <p class="card__footer-text">
                  <span class="card__footer-em">{{ item.footer[0] }}</span>
                </p>
                <p class="card__footer-text">{{ item.footer[1] }}</p>
              </template>
            </div>
          </div>
        </swiper-slide>
      </swiper>
    </div>

    <div class="wrapper">
      <a class="btn" @click="zixun('查看AI测试发展前景')">查看AI测试发展前景</a>
      <p class="tip">
        * 数据来源于猎聘、职友集、脉脉、亿欧智库等平台发布的AI行业招聘数据与市场研究报告
      </p>
    </div>
  </div>
</template>

<script>
import pageTitle from "../common/pageTitle.vue";
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    pageTitle,
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        slidesPerView: "auto",
        spaceBetween: 16,
      },
      list: [
        {
          title: "人才紧缺 均薪高达27.5K",
          image: require("../../../assets/coursePage/softwareTest/box3/card-salary.png"),
          footer: ["AI测试岗位薪资", "18,000~45,000元"],
        },
        {
          title: "岗位需求量1年激增300%",
          image: require("../../../assets/coursePage/softwareTest/box3/card-demand.png"),
          footer: [
            "全行业AI化，2000亿市场爆发",
            "测试需求暴涨，供需比0.39，",
            "5岗抢2人",
          ],
        },
        {
          title: "职业路径长 能干到退休",
          image: require("../../../assets/coursePage/softwareTest/box3/card-career.png"),
          footer: ['资深测试"越老越香"', "薪资一路走高"],
        },
      ],
    };
  },
  methods: {
    zixun(name) {
      this.mai("软件测试-就业课", name, 0, null);
      this.clickZiXun();
    },
  },
};
</script>

<style lang="less" scoped>
.wrapper {
  padding: 0 32px;
}

.box3 {
  padding: 80px 0 88px;
  box-sizing: border-box;
  width: 100%;
  background: url("../../../assets/coursePage/softwareTest/box3/bg.png")
    no-repeat center top;
  background-size: 100% 100%;
  overflow: hidden;

  .subject-content {
    position: relative;
    margin-top: 48px;
    padding: 0 32px;
    box-sizing: border-box;

    /deep/.swiper-container {
      overflow: unset;
    }
  }

  .swiper-slide {
    width: 626px;
    height: auto;
  }

  .card {
    box-sizing: border-box;
    width: 100%;
    min-height: 668px;
    padding: 40px 24px 36px;
    background: #ffffff;
    border-radius: 24px;
    box-shadow: -8px 8px 42px 0px rgba(37, 84, 131, 0.2);

    &__header {
      display: flex;
      align-items: center;
    }

    &__icon {
      flex-shrink: 0;
      width: 64px;
      height: 64px;
    }

    &__title {
      margin: 0 0 0 8px;
      font-family: PingFangSC-Semibold, PingFang SC;
      font-size: 34px;
      font-weight: 600;
      color: #1f375f;
      line-height: 48px;
    }
    &__chart--2{

    }
    &__chart {
      display: block;
      margin: 24px auto 0;

      &--0 {
       
        height: 406px;
      }

      &--1 {
       
        height: 406px;
      }

      &--2 {
       
        height: 406px;
      }
    }

    &__footer {
      margin-top: 32px;
      text-align: center;
    }

    &__footer-text {
      margin: 0;
      font-family: PingFangSC, PingFang SC;
      font-size: 28px;
      font-weight: 400;
      color: #84909d;
      line-height: 40px;
    }

    &__footer-highlight {
      font-family: Arial-Bold, Arial;
      font-size: 32px;
      font-weight: 700;
      color: #0049ff;
      line-height: 44px;
    }

    &__footer-em {
      font-family: PingFangSC-Semibold, PingFang SC;
      font-weight: 600;
      color: #0049ff;
    }
  }

  .btn {
    font-size: 32px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: #ffffff;
    line-height: 96px;
    text-align: center;
    width: 686px;
    height: 96px;
    background: linear-gradient(224deg, #37abff 0%, #3d8efd 100%);
    border-radius: 48px;
    display: block;
    margin: 64px auto 0;
  }

  .tip {
    margin: 24px 0 0;
    font-size: 24px;
    font-family: PingFangSC-Regular, PingFang SC;
    font-weight: 400;
    color: #89acd5;
    line-height: 34px;
    text-align: center;
  }
}
</style>
